import { createContext, useContext, useState, useCallback } from 'react';
import AlertDialog from '../components/ui/AlertDialog';

const AlertContext = createContext(null);

export function AlertProvider({ children }) {
  const [alert, setAlert] = useState(null);

  const showAlert = useCallback(({ type = 'error', title, message }) => {
    setAlert({ type, title, message });
  }, []);

  const closeAlert = useCallback(() => setAlert(null), []);

  return (
    <AlertContext.Provider value={showAlert}>
      {children}
      <AlertDialog
        isOpen={!!alert}
        onClose={closeAlert}
        type={alert?.type}
        title={alert?.title}
        message={alert?.message}
      />
    </AlertContext.Provider>
  );
}

export function useAlert() {
  const ctx = useContext(AlertContext);
  if (!ctx) throw new Error('useAlert must be used within AlertProvider');
  return ctx;
}
